import { DateTime } from "luxon";

const GLOBAL_DISCOUNT = {
  discount: 20, // 10% global discount
  start: DateTime.fromObject(
    { year: 2025, month: 8, day: 12, hour: 23, minute: 59, second: 59 },
    { zone: "Europe/London" }
  ),
  end: DateTime.fromObject(
    { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
    { zone: "Europe/London" }
  ),
};

const PRODUCT_DISCOUNTS = {
  // discount for july
  "6798b6e3e6a99b6c6c1be5e3": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  "6798b6e3e6a99b6c6c1be5e5": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  "68556ba102acaf9a8f72eed5": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  "679b4f44e6a99b6c6c1be65d": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  "6798b078e6a99b6c6c1be4c3": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  "6798b078e6a99b6c6c1be4c4": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  "6798b3dde6a99b6c6c1be568": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  // newly added for 19 to 20 july
  "68628dc3358ced0187a852aa": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 7, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  //slots for august

  "68629bcf809ffe1e1eaa85d8": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68629bcf809ffe1e1eaa85da": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68627dccc2d10b69a7384d18": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "686297ee809ffe1e1eaa853b": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68629b33809ffe1e1eaa859c": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68628dc3358ced0187a852ac": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "686cc935a58a732ec7abbf84": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68628dc3358ced0187a852b0": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "689af99ecf83fb7cbbb8cc78": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 8, day: 31, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  // slots for september

  "68629bcf809ffe1e1eaa85de": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68629bcf809ffe1e1eaa85e0": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68627dccc2d10b69a7384d1c": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "686297ee809ffe1e1eaa8543": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68629b33809ffe1e1eaa85a2": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68629b33809ffe1e1eaa85a6": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68628dc3358ced0187a852b4": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },
  "68629a6f809ffe1e1eaa8583": {
    discount: 30,
    start: DateTime.fromObject(
      { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
      { zone: "Europe/London" }
    ),
    end: DateTime.fromObject(
      { year: 2025, month: 9, day: 30, hour: 23, minute: 59, second: 59 },
      { zone: "Europe/London" }
    ),
  },

  // // slots for october
  // "68629a6f809ffe1e1eaa8588": {
  //   discount: 30,
  //   start: DateTime.fromObject(
  //     { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
  //     { zone: "Europe/London" }
  //   ),
  //   end: DateTime.fromObject(
  //     { year: 2025, month: 10, day: 30, hour: 23, minute: 59, second: 59 },
  //     { zone: "Europe/London" }
  //   ),
  // },
  // "68629b33809ffe1e1eaa85aa": {
  //   discount: 30,
  //   start: DateTime.fromObject(
  //     { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
  //     { zone: "Europe/London" }
  //   ),
  //   end: DateTime.fromObject(
  //     { year: 2025, month: 10, day: 30, hour: 23, minute: 59, second: 59 },
  //     { zone: "Europe/London" }
  //   ),
  // },
  // "68628dc3358ced0187a852b8": {
  //   discount: 30,
  //   start: DateTime.fromObject(
  //     { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
  //     { zone: "Europe/London" }
  //   ),
  //   end: DateTime.fromObject(
  //     { year: 2025, month: 10, day: 30, hour: 23, minute: 59, second: 59 },
  //     { zone: "Europe/London" }
  //   ),
  // },
  // "686297ee809ffe1e1eaa854c": {
  //   discount: 30,
  //   start: DateTime.fromObject(
  //     { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
  //     { zone: "Europe/London" }
  //   ),
  //   end: DateTime.fromObject(
  //     { year: 2025, month: 10, day: 30, hour: 23, minute: 59, second: 59 },
  //     { zone: "Europe/London" }
  //   ),
  // },
  // "68629bcf809ffe1e1eaa85e3": {
  //   discount: 30,
  //   start: DateTime.fromObject(
  //     { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
  //     { zone: "Europe/London" }
  //   ),
  //   end: DateTime.fromObject(
  //     { year: 2025, month: 10, day: 30, hour: 23, minute: 59, second: 59 },
  //     { zone: "Europe/London" }
  //   ),
  // },
  // "68627dccc2d10b69a7384d20": {
  //   discount: 30,
  //   start: DateTime.fromObject(
  //     { year: 2025, month: 6, day: 17, hour: 0, minute: 0, second: 0 },
  //     { zone: "Europe/London" }
  //   ),
  //   end: DateTime.fromObject(
  //     { year: 2025, month: 10, day: 30, hour: 23, minute: 59, second: 59 },
  //     { zone: "Europe/London" }
  //   ),
  // },
};

const EXCLUDED_PARENT_IDS = new Set([
  "66028dcab9e94f407d047293",
  "66028e0cb9e94f407d0472ac",
  "66028e27b9e94f407d0472c5",
  "66028e42b9e94f407d0472de",
  "67a1f581d2efc2c13a5ac516",
  "67a1f5bcd2efc2c13a5ac526",
  "67a1f5f5d2efc2c13a5ac536",
]);

export function getDiscountInfo(
  productId,
  parentId,
  now = DateTime.now().setZone("Europe/London")
) {
  let discount = 0;
  let matched = false;
  let expired = false;

  if (PRODUCT_DISCOUNTS[productId]) {
    matched = true;
    const productDiscount = PRODUCT_DISCOUNTS[productId];
    const isActive = now >= productDiscount.start && now <= productDiscount.end;

    if (isActive) {
      discount = productDiscount.discount;
    } else {
      expired = now > productDiscount.end;
    }
  }

  if (discount === 0) {
    // console.log(parentId, EXCLUDED_PARENT_IDS.has(parentId));
    if (parentId && EXCLUDED_PARENT_IDS.has(parentId)) {
      return { matched, discount: 0, expired };
    }

    const isGlobalActive =
      now >= GLOBAL_DISCOUNT.start && now <= GLOBAL_DISCOUNT.end;
    if (isGlobalActive) {
      discount = GLOBAL_DISCOUNT.discount;
    }
  }

  return { matched, discount, expired };
}
